import { ExportConfig } from './types'
import { useOnceOffTransactionExportBase } from './useOnceOffTransactionExportBase'

interface UseOnceOffRewardsTransactionsExportProps {
  handleClose: () => void
  walletId?: string
}

/**
 * Rewards-specific transaction export hook
 * Provides export functionality for rewards transactions
 *
 * Features:
 * - Single wallet export only (no download all)
 * - Transaction reports only (no balance reports)
 *
 * @param props - Configuration for rewards export
 * @returns Transaction export hook result with all necessary state and handlers
 *
 * @example
 * const exportValues = useOnceOffRewardsTransactionsExport({
 *   handleClose: () => setModalOpen(false),
 *   walletId: 'wallet-123'
 * })
 */
export const useOnceOffRewardsTransactionsExport = ({
  handleClose,
  walletId,
}: UseOnceOffRewardsTransactionsExportProps) => {
  const config: ExportConfig = {
    walletIdResolver: () => ({
      lsid: walletId,
    }),

    // Add rewards-specific amplitude properties
    amplitudePropsExtras: () => ({
      page: 'rewards',
    }),

    // Feature configuration
    features: {
      allowBalanceReport: false, // Rewards only supports transaction reports
    },

    // Error context for Sentry
    errorContext: 'RewardsTransactionExport',
  }

  return useOnceOffTransactionExportBase(config, handleClose)
}
